import {Component, Input, OnInit ,ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-help-section',
  templateUrl: './help-section.component.html',
  styleUrls: ['./help-section.component.scss']
})
export class HelpSectionComponent implements OnInit {
  popRef: NgbActiveModal;
  @ViewChild ('helpSection', {static: true} ) helpSection;
  config = {
    // keyboard: false,
    // animation:true,
    // backdrop: 'static',
    windowClass: 'right-side-modal right-side-modal-help'
  };

  constructor(private modalService: NgbModal) {
  }
  public helpFulData: any;
  @Input('helpSectionData')
  set helpLinks(val) {
    this.helpFulData = val;
  }

  ngOnInit() {
  }
  openHelpfulLink(){
    this.popRef = this.modalService.open(this.helpSection,this.config);

  }

}
